import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { OfficeType } from '@application/Types/ComponentTypes'
import { BackgroundImage } from '@src/Application/Interfaces/Atoms/BackgroundImage/BackgroundImage'
import { Image } from '@src/Application/Interfaces/Atoms/Image'
import { Link } from '@src/Application/Interfaces/Atoms/Link/Link'

import { BackgroundImageWrapper, Description, HelperText, IconWrapper, Row, Title, Wrapper } from './Office.styled'

export const Office = ({
    title,
    officeImage,
    officeImageAnimation,
    timing,
    timingIcon,
    timezone,
    phone,
    phoneIcon,
    email,
    emailIcon,
    address,
    addressIcon,
}: OfficeType): JSX.Element => {
    const image = getImage(officeImage.localFile) as IGatsbyImageData
    const WrapperTilt = officeImageAnimation ? Tilt : React.Fragment
    return (
        <Wrapper>
            <WrapperTilt>
                <BackgroundImageWrapper>
                    <BackgroundImage image={image} title={officeImage.alternativeText}>
                        <Title>{title}</Title>
                    </BackgroundImage>
                </BackgroundImageWrapper>
            </WrapperTilt>
            {timing && (
                <Row>
                    <IconWrapper>{timingIcon && <Image image={timingIcon} />}</IconWrapper>
                    <Description>
                        {timing}
                        {timezone && <HelperText>{timezone}</HelperText>}
                    </Description>
                </Row>
            )}
            {phone && (
                <Row>
                    <IconWrapper>{phoneIcon && <Image image={phoneIcon} />}</IconWrapper>
                    <Description>{phone}</Description>
                </Row>
            )}
            {email && (
                <Row>
                    <IconWrapper>{emailIcon && <Image image={emailIcon} />}</IconWrapper>
                    <Link to={`mailto:${email}`}>{email}</Link>
                </Row>
            )}
            {address && (
                <Row>
                    <IconWrapper>{addressIcon && <Image image={addressIcon} />}</IconWrapper>
                    <Description>{address}</Description>
                </Row>
            )}
        </Wrapper>
    )
}
